// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/rbac.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message omnios.v1.RoleDefinition
 */
export const RoleDefinition = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RoleDefinition",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_system", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "permissions", kind: "message", T: RolePermission, repeated: true },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.RolePermission
 */
export const RolePermission = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RolePermission",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "resource", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListRolesRequest
 */
export const ListRolesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListRolesRequest",
  () => [
    { no: 1, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListRolesResponse
 */
export const ListRolesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListRolesResponse",
  () => [
    { no: 1, name: "roles", kind: "message", T: RoleDefinition, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetRoleRequest
 */
export const GetRoleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetRoleRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateRoleRequest
 */
export const CreateRoleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateRoleRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "permissions", kind: "message", T: PermissionEntry, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdateRoleRequest
 */
export const UpdateRoleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateRoleRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "permissions", kind: "message", T: PermissionEntry, repeated: true },
    { no: 5, name: "replace_permissions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteRoleRequest
 */
export const DeleteRoleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteRoleRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PermissionEntry
 */
export const PermissionEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PermissionEntry",
  () => [
    { no: 1, name: "resource", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CheckPermissionRequest
 */
export const CheckPermissionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CheckPermissionRequest",
  () => [
    { no: 1, name: "resource", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CheckPermissionResponse
 */
export const CheckPermissionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CheckPermissionResponse",
  () => [
    { no: 1, name: "allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

